<template>
  <div class="main">
    <template v-if="$store.state.isMobile == 2">
      <div class="top_native">
        <div class="caseTitle animate__animated animate__zoomIn">
          <div class="chinese">产品与方案</div>
          <div class="engli">PRODUCTS AND SOLUTIONS</div>
        </div>
        <!-- <div class="contentNav">
          <template v-for="(item, index) in editData">

            <div class="left" :key="item.name" :class="{ 'center': index == 1, 'right': index == 2 }">
              <div class="title" @click="navigateTo('/mapmost')">{{ item.name }}</div>
              <div class="line"></div>
              <template v-for="o in item.childrenList">
                <div class="label">{{ o.name }}</div>
                <div class="btnArr">
                  <template v-for="obj in o.childrenList">

                    <el-dropdown v-if="obj.childrenList" placement="top" style="width: 100%;">
                      <div class="bottomBtn">

                        <span>{{ obj.name }}</span>
                        <img src="@/assets/img/icon/urlright.png" alt="" />
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="childObj in obj.childrenList">
                          <div @click="pdfUrl(childObj.reqUrl, '', index, childObj,item.name,o.name)">{{ childObj.name }}</div>
                        </el-dropdown-item>

                      </el-dropdown-menu>
                    </el-dropdown>
                    <div v-else class="bottomBtn" @click="pdfUrl(obj.reqUrl, '', index, obj,item.name,o.name)">
                      <span>{{ obj.name }}</span>
                      <img src="@/assets/img/icon/urlright.png" alt="" />
                    </div>
                  </template>
                </div>
              </template>
              <Products v-if="$store.state.editStatus === 0" :orname="item.name" :list="item" @onClose="getList" :index="index" />
            </div>
          </template>

        </div>-->
      </div>
      <div class="conts">
        <div class="navLists">
          <div class="navItem" v-for="(item, index) in editData" :key="item.id || index"
            :class="{ active: index == active_nav_index }" @click="setActiveNavIndex(index)">
            <div class="editBox">
              {{ item.name }}
            </div>
            <Products v-if="$store.state.editStatus === 0" :orname="item.name" :list="item" @onClose="getList"
              :index="index" />
          </div>
        </div>
        <!-- 除专题资料 -->
        <div class="navConts" id="solutioNav" v-if="activeNavData" :key="navContentKey">
          <div class="navContItem" v-for="(item, index) in activeNavData.childrenList" :key="item.id || item.name || index">
            <template v-if="activeNavData.name != '专题资料'">
              <div class="labelTitle">{{ item.name }}</div>
              <div class="labels">
                <div class="labelItem" v-for="childItem in item.childrenList" :key="childItem.id || childItem.name">
                  <div
                    @click="pdfUrl(childItem.reqUrl, '', index, childItem, activeNavData.name, item.name)">
                    <el-dropdown v-if="childItem.childrenList" placement="top" style="width: 100%;">
                      <div class="bottomBtn">
                        <!-- <span style="color:#8295AC;"> {{ childItem.name }}</span> -->
                        <span> {{ childItem.name }}</span>
                      </div>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="childObj in childItem.childrenList" :key="childObj.id || childObj.name">
                          <div @click="pdfUrl(childObj.reqUrl, '', index, childObj, item.name, childObj.name)">{{
                            childObj.name }}
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <div v-else class="bottomBtn"
                      @click="pdfUrl(childItem.reqUrl, '', index, childItem, item.name, childItem.name)">
                      <span> {{ childItem.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <!-- 专题资料 -->
              <div class="labels" style="width: 70vw;">
                <div class="labelTitle imgFlex">
                  <div class="labelItem imgBook"
                    @click="pdfUrl(childItem.reqUrl, '', index, childItem, item.name, childItem.name)"
                    :style="{ backgroundImage: 'url(' + childItem.logo + ')' }" v-for="childItem in item.childrenList"
                    :key="childItem.id || childItem.name">
                    <div class="bottomBtn imgFont">
                      <!-- <template v-if="childItem.name.length <= 10">
                        <span :class="childItem.name.length > 10 ? 'imgFontCartoon' : ''"
                          @click.stop="downPDF(childItem.reqUrl)"> {{ childItem.name }}</span>
                      </template>
                      <template v-else @click.stop="downPDF(childItem.reqUrl)">
                        <span @click.stop="downPDF(childItem.reqUrl)"
                          :class="childItem.name.length > 10 ? 'imgFontCartoon' : ''"> {{ childItem.name }}
                        </span>
                      </template> -->
                      <template>
                        <span @click.stop="downPDF(childItem.reqUrl)" style="color:#fff;"> {{ childItem.name }}</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

      </div>
      <CopyRight></CopyRight>
    </template>
    <template v-else>
      <mobileSolutionNav :listData="listData" />
    </template>
    <div class="TrialsList" @click="dialogVisibleTable = true; getProductUseList()" v-if="$store.state.editStatus === 0">
      <span>查看数据</span>
    </div>
    <el-dialog :visible.sync="dialogVisibleTable" width="80%" :before-close="handleClose">
      <template slot="title">
        <div class="dialog-header">
          <span>产品申请试用</span>
          <el-button type="primary" size="mini" class="dialog-header-btn" @click="exportData">导出</el-button>
        </div>
      </template>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column fixed prop="product" label="产品名称">
        </el-table-column>
        <el-table-column prop="name" label="姓名">
        </el-table-column>
        <el-table-column prop="phone" label="电话">
        </el-table-column>
        <el-table-column prop="company" label="单位名称">
        </el-table-column>
        <el-table-column prop="duties" label="职务">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>
        <el-table-column prop="isFollowUp" label="是否回访">
          <template slot-scope="scope">
            <span v-if="scope.row.isFollowUp !== 0" style="color: green;">已回访</span>
            <span v-else style="color: red;">未回访</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="queryHF(scope.row.id)">确认回访</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages">
        <el-pagination small layout="prev, pager, next" :total="total" @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getProductProgrammeList, getProductUseList, followUp, exportProductUseList } from "../../api/solutio";
import Products from "../models/products.vue"
import mobileSolutionNav from "../mobile/mobileSolutionNav.vue"
import { saveAs } from 'file-saver';
export default {
  name: "Solution",
  components: {
    Products,
    mobileSolutionNav
  },
  data() {
    return {
      nav_list: ["测绘服务", "数据服务", "数智应用"],
      active_nav_index: 0,
      nav_btn_arr: [
        ["基础测绘", "全生命周期测绘服务"],
        ["自然资源综合调查", "行业专项调查", "摄影测量与遥感", "三维数据服务", "数据综合治理", "全链条数字化方案", '数据融合分析'],
        ["自然资源", "住房建设", "社会治理", "农业农村", "智慧产业园", "水务环境", "智慧交通"],
      ],
      listData: [],//原始数据
      editData: [],//编辑的数据
      dialogVisibleTable: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      itemData: {},
      navRenderKey: 0

    };
  },
  computed: {
    activeNavData() {
      return this.editData[this.active_nav_index] || null;
    },
    navContentKey() {
      const activeNavData = this.activeNavData;
      return [
        this.$store.state.language,
        this.navRenderKey,
        this.active_nav_index,
        activeNavData && (activeNavData.id || activeNavData.name)
      ].join('-');
    },
    isAllNameSpecialData() {
      return this.editData.length > 0 && this.editData.every(item => item.name === '专题资料');
    }
  },
  mounted() {

    if (this.$store.state.isMobile == 2) {
      this.getList();
      window.scrollTo(0, 0);
      this.$wow.init();
      this.total = 0;
    }


  },
  watch: {
    '$store.state.cpTabIndex': function (newVal, oldVal) {
      this.setActiveNavIndex(newVal);
      window.scrollTo({
        top: 500,
        left: 0,
        behavior: "smooth"
      });
    },
    '$store.state.language': function () {
      this.navRenderKey += 1;
    }
  },
  methods: {
    setActiveNavIndex(index) {
      const nextIndex = Number(index);
      if (Number.isNaN(nextIndex) || nextIndex < 0 || nextIndex >= this.editData.length) {
        return;
      }

      this.active_nav_index = nextIndex;
      this.navRenderKey += 1;
    },
    // 下载pdf
    async downPDF(e) {
      // 加载现有 PDF 文档
      // const existingPdfBytes = await fetch(e).then(res => res.arrayBuffer());
      // const pdfDoc = await PDFDocument.load(existingPdfBytes);
      //       // 序列化修改后的 PDF
      // const pdfBytes = await pdfDoc.save();
      const response = await fetch(e);
      if (!response.ok) throw new Error('Network response was not ok.');
      const pdfBytes = await response.blob(); // 获取 Blob 数据
      // 创建一个 Blob 对象，并使用它来下载文件
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = e;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportData() {
      let productUstReqVO = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        isFollowUp: '',
        product: ''
      }
      exportProductUseList(productUstReqVO).then((response) => {
        console.log(response, 'res')
        const blob = new Blob([response.data], {
          // 下载的文件格式自己在这边更改type的值就好了
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, '申请试用.xls'); // 使用file-saver库保存文件
      }).catch((error) => {
        console.log(error, 'err')
      })
    },
    getProductUseList() {
      let params = {
        "pageNum": this.pageNum || 1,
        "pageSize": this.pageSize || 10,
      }
      getProductUseList(params).then(res => {
        this.total = res.data.total;
        this.tableData = res.data.list;
        this.itemData = res.data.list[0].childrenList
      })
    },
    getList() {
      getProductProgrammeList({ isRelease: this.$store.state.editStatus }).then(res => {
        this.listData = res.data;
        this.editData = res.data;
      })
    },
    navigateTo(url) {
      this.$router.push(url);
    },
    toMapmost(url) {
      window.open(url);
    },
    ss(name) {
      if (name == "社会治理") {
        this.$router.push('/solution');
      } else if (name == "产业经济") {
        this.$router.push({ path: '/economy', query: { type: 'economy' } });
      } else if (name == `“多测合一”跟踪服务`) {
        this.$router.push({ path: '/economy', query: { type: 'track' } });
      } else if (name == `规划建设`) {
        this.$router.push({ path: '/economy', query: { type: 'output' } });
      } else if (name == `智慧交通解决方案`) {
        this.$router.push({ path: '/economy', query: { type: 'traffic' } });
      } else if (name == `自然资源综合调查`) {
        this.$router.push({ path: '/economy', query: { type: 'resources' } });
      }
    },
    pdfUrl(pdf = "", url = "", type = "", obj, orname, scname) {
      console.log(obj, 'obj')
      if (obj.childrenList != null) {
        return
      }
      let d = new Date()

      if (obj.urlType == 4) {

        this.$router.push({
          path: '/pageTemplate',
          query: {
            data: JSON.stringify(
              obj
            ),
            orname: orname,
            scname: scname
          }
        })


        return
      }

      if (pdf.indexOf('.pdf') > -1 && pdf.endsWith('.pdf')) {
        this.$router.push({ path: '/productPdf', query: { name: pdf, url: url, type: type, productName: obj.name, parentId: obj.parentId, objId: obj.id, t: d.getTime(), } });
      } else if (pdf.indexOf('.html') || pdf.indexOf('/#/')) {
        window.open(pdf)
      } else {
        this.$router.push({ path: '/productPdf', query: { name: pdf, url: url, type: type, productName: obj.name, parentId: obj.parentId, objId: obj.id, t: d.getTime(), } })
      }



    },
    queryHF(id) {
      followUp(id).then((res) => {
        this.$message.success('处理成功');
        this.pageNum = 1;
        this.getProductUseList()
      })
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/customAnimation.css';

.imgFont {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: black;
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: space-around;
  align-items: center;
  opacity: 0.6;
  overflow: hidden;
  /* 隐藏超出部分 */
  white-space: nowrap;
  /* 不换行 */

  span {
    color: white;
  }
}
.imgFontCartoon {
  color: white;
  display: inline-block;
  padding-left: 100%;
  /* 开始时推出视图外 */
  animation: marquee 10s linear infinite;
  /* 应用动画 */
}

@keyframes marquee {
  from {
    transform: translateX(0);
    /* 从当前位置开始 */
  }

  to {
    transform: translateX(-100%);
    /* 向左移动元素的全宽 */
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 30px;
}

.dialog-header-btn {
  margin-left: auto;
}

.main {
  margin-top: 60px;

  >div {
    width: 100%;
    background-size: cover;
  }
}

.topTitle {
  color: #044095;
  padding-top: 50px;
}

.top_native {
  height: 500px;
  height: 500px;
  background: url(../../assets/img/solution/nav_bg.png) no-repeat center;

  .caseTitle {
    width: 635px;
    position: absolute;
    top: 150px;
    left: 120px;
    font-family: Source Han Sans CN;
    font-size: 61px;
    font-weight: bold;

    .chinese {
      text-align: left;
      width: 100%;
      color: #003988;
    }

    .engli {
      font-size: 41px;
      margin-top: 20px;
      padding: 10px 30px;
      background: #003988;
      width: fit-content;
      color: #cbe3fe;
      font-style: italic;
    }
  }
}

.contentNav {
  width: 1920px;
  padding: 0 150px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  margin-top: 60px;

  .title {
    width: 227px;
    font-size: 24px;
    font-family: Alimama ShuHeiTi;
    font-weight: bold;
    font-style: italic;
    color: #2d72ff;
    text-align: left;
  }

  .line {
    width: 124px;
    height: 4px;
    background-color: #2d72ff;
    margin-top: 9px;
  }

  .left,
  .center,
  .right {
    width: 386px;
    min-height: 100%;
    position: relative;
  }

  .left {
    padding: 30px;
    box-sizing: border-box;
    text-align: left;
    background: url(../../assets/img/solution/mapmost_bg.png);
    box-shadow: 0 0 10px 5px #ddd;
    border-radius: 5px;
    // background: #f6f6f6;
    background-size: 100% 100%;

    p {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 23px;
      margin-top: 24px;
      margin-bottom: 22px;
    }

    .label {
      height: 39px;
      background-image: url('../../assets/img/icon/label1.png');
      background-size: 100% 100%;
      line-height: 39px;
      padding-left: 33px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 600;
      color: #ffffff;
      margin-top: 20px;
    }

    .bottomBtn {
      cursor: pointer;
      color: #8295AC;
    }



    .btnArr {
      .bottomBtn {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 19px;
        padding: 0 20px;
        box-sizing: border-box;


        span {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 600;
          color: #2a7aff;
          line-height: 16px;
        }

        img {
          margin-left: 10px;
        }
      }
    }
  }

  .center {
    width: 660px;
    margin-left: 15px;
    background: url(../../assets/img/solution/center_bg.png);
    box-shadow: 0 0 10px 5px #ddd;
    border-radius: 5px;
    background-size: 100% 100%;
    padding: 30px;
    box-sizing: border-box;
    text-align: left;

    .label {
      height: 39px;
      background-image: url('../../assets/img/icon/label3.png');
    }

    .btnArr {
      display: grid;
      grid-template-columns: repeat(2, 50%);
      grid-template-rows: auto;
    }
  }

  .right {
    flex: 1;
    margin-left: 15px;
    background: url(../../assets/img/solution/experience_bg.png);
    background-size: 100% 100%;
    padding: 30px;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 0 0 10px 5px #ddd;
    border-radius: 5px;

    .label {
      height: 39px;
      background-image: url('../../assets/img/icon/label2.png');
    }

    .btnArr {
      display: grid;
      grid-template-columns: 55% 45%;
      grid-template-rows: auto;
    }
  }
}

.conts {
  display: flex;
  min-height: 690px;
  max-width: 100%;

  .navLists {
    width: 532px;
    background-image: url(../../assets/img/cpfa.png);
    background-size: 100% 100%;
    text-align: right;
    padding: 42px 0;

    .navItem {
      width: 436px;
      height: 152px;
      display: inline-block;
      text-align: left;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 600;
      color: #00398a;

      padding-left: 64px;
      cursor: pointer;
      position: relative;

      &:hover {
        color: #d7000f;
      }

      .editBox {
        height: 152px;
        line-height: 152px;
        position: relative;
      }
    }

    .active {
      background-image: url(../../assets/img/cpfaNav.png);
      background-size: 100% 100%;
      color: #d7000f;
    }
  }

  .navConts {
    width: calc(100% - 532px);
    background-color: #EEF6FF;
    display: grid;
    grid-template-columns: repeat(3, 32%);
    grid-column-gap: 20px;
    padding: 120px 56px;
    box-sizing: border-box;

    .navContItem {
      position: relative;

      .labelTitle {
        font-size: 22px;
        font-family: Microsoft YaHei;
        font-weight: 600;
        color: #333333;
      }

      .labels {
        display: flex;
        margin-top: 10px;
        flex-wrap: wrap;

        .imgFlex {
          display: flex;
          justify-content: left;
          flex-wrap: wrap;
        }

        // .labelItem {
        //   font-size: 14px;
        //   font-family: Microsoft YaHei;
        //   font-weight: 600;
        //   color: #8295AC;
        //   background: #EEF6FF;
        //   border: 1px solid #8295AC;
        //   border-radius: 2px;
        //   padding: 5px 15px;
        //   box-sizing: border-box;
        //   margin-right: 10px;
        //   white-space: nowrap;
        //   cursor: pointer;
        //   margin-bottom: 10px;
        // }
        .labelItem {
          flex: 45%;
          // font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 600;
          background: #EEF6FF;
          border-radius: 2px;
          padding: 5px 0;
          box-sizing: border-box;
          margin-right: 10px;
          white-space: nowrap;
          cursor: pointer;
          margin-bottom: 10px;
        }
        .labelItem,span {
          color: #003988;
          font-size: 17px;
          word-wrap: break-word;
          white-space: pre-wrap;
        }

        .imgBook {
          flex: none;
          width: 150px;
          height: 200px;
          position: relative;
          background-size: 100% 100%;
        }
      }
    }
  }
}

.TrialsList {
  position: absolute;
  display: inline-block;
  top: 80px;
  right: 0;
  width: 70px !important;
  text-align: center;
  padding: 4px 10px;
  background: #007dff;
  color: #fff;
  font-size: 14px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  cursor: pointer;
}

.pages {
  text-align: center;
  margin-top: 10px;
}
</style>
